import ColorGrid from './ColorGrid';

export default ColorGrid;
